import React from 'react';
import { Box, IconButton, SxProps } from '@mui/material';
import { CloseFormShowButton, SaveFormShowButton, useFormShowContext, useFormContext } from 'framework/form';
import CloseIcon from '@mui/icons-material/Close';

interface FormActionButtonsProps {
  onCancel?: () => void;
  withDefaultToggle?: boolean;
  sxWrapper?: SxProps;
}

const FormActionButtons: React.FC<FormActionButtonsProps> = ({ onCancel, withDefaultToggle, sxWrapper }) => {
  const { isSubmitEnabled } = useFormContext();
  const { toggleEditMode } = useFormShowContext();
  const handleCancel = () => {
    if (withDefaultToggle) {
      toggleEditMode();
    }
    onCancel?.();
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, ml: 2, ...sxWrapper }}>
      <SaveFormShowButton />
      {onCancel ? (
        <IconButton disabled={!isSubmitEnabled} onClick={handleCancel}>
          <CloseIcon color="error" />
        </IconButton>
      ) : (
        <CloseFormShowButton />
      )}
    </Box>
  );
};

export default FormActionButtons;
